import { createSlice } from "@reduxjs/toolkit";
import { userAuthApi } from "../services/userAuthApi";

const initialState = {
  // token: '',
  // csrf_token: '',
  user: null,
};

export const authSlice = createSlice({
  name: "authInfo",
  initialState,
  reducers: {
    //  setAuthInfo:(state, action)=> {
    //     state.token = action.payload.token;
    //     state.csrf_token = action.payload.csrf_token;
    //   },
    //   unsetAuthInfo:(state, action)=> {
    //     state.token = action.payload.token;
    //     state.csrf_token = action.payload.csrf_token;
    //  },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        userAuthApi.endpoints.loginUser.matchFulfilled,
        (state, { payload }) => {
          state.user = payload.data;
          localStorage.setItem(
            "userInfo",
            JSON.stringify({
              id: payload.data.id,
              name: payload.data.name,
              email: payload.data.email,
              image_url: payload.data.image_url,
            })
          );
        }
      )
      .addMatcher(userAuthApi.endpoints.loginUser.matchRejected, (state) => {
        state.user = null;
      });
  },
});

export const { setAuthInfo, unsetAuthInfo } = authSlice.actions;

export default authSlice.reducer;
